import React, { createContext, useContext, useMemo } from 'react';
import { FeatureFlags, DEFAULT_FEATURE_FLAGS } from '@/utils/featureFlags';

const FeatureFlagsContext = createContext<FeatureFlags>(DEFAULT_FEATURE_FLAGS);

interface FeatureFlagsProviderProps {
  flags: FeatureFlags;
  children: React.ReactNode;
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({ flags, children }) => {
  const value = useMemo(() => flags, [flags]);

  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlags = (): FeatureFlags => {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  return context;
};
